import { render, staticRenderFns } from "./PopUpVideoThree.vue?vue&type=template&id=5a2169f0&"
import script from "./PopUpVideoThree.vue?vue&type=script&lang=js&"
export * from "./PopUpVideoThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports